import React from 'react';
import { ReleaseEntryView } from './ReleaseEntryView';
import type { ReleaseEntry } from '../../types/changelog';
export function ReleaseTimeline({
  entries
}: {
  entries: ReleaseEntry[];
}) {
  const months = entries.reduce<{
    month: string;
    items: ReleaseEntry[];
  }[]>((groups, entry) => {
    const last = groups[groups.length - 1];
    if (last && last.month === entry.month) last.items.push(entry);else groups.push({
      month: entry.month,
      items: [entry]
    });
    return groups;
  }, []);
  return <ol className="space-y-12 lg:space-y-0" data-id="element-1717" data-mp="2e2zaafpysu9c">
      {months.map(group => <li key={group.month} className="grid grid-cols-1 lg:grid-cols-[180px_minmax(0,1fr)] lg:gap-10" data-id="element-1718" data-mp="2szqfj5mbl06v">
          <h2 className="self-start border-b border-canvas-line pb-3 text-[15px] font-semibold text-ink lg:sticky lg:top-[96px] lg:border-0 lg:pb-0 lg:pt-0.5 lg:text-right" data-id="element-1719" data-mp="2o0x037nh2z42">
            {group.month}
          </h2>
          <div className="mt-6 space-y-12 lg:mt-0 lg:border-l lg:border-canvas-line lg:pb-16 lg:pl-10" data-id="element-1720" data-mp="3axxzet3zk9d">
            {group.items.map(entry => <ReleaseEntryView key={entry.id} entry={entry} data-id="element-1721" data-mp="nbbq4zsz0scw" />)}
          </div>
        </li>)}
    </ol>;
}